export const checkboxList = [
    {
      id:"Home",
      title: "Home",
      checkboxGroupListMain: [
        {
          
            groupTitle: "Posts",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "Compose shoutouts",
              name: "ComposeShoutouts",
              value: "ComposeShoutouts",
            },
            {
              label: "Comment on shoutouts",
              name: "Comment on shoutouts",
              value: "Comment on shoutouts",
            },
            {
              label: "Pin shoutouts",
              name: "Pin shoutouts",
              value: "Pin shoutouts",
            },
            {
              label: "Manage everyone’s shoutouts posts",
              name: "Manage everyone’s shoutouts posts",
              value: "Manage everyone’s shoutouts posts",
            },
            {
              label: "Delete everyone’s shoutout comments",
              name: "Delete everyone’s shoutout comments",
              value: "Delete everyone’s shoutout comments",
            },
          ],
        },
      ],
    },
    {
        id:"Teams",
      title: "Teams",
      checkboxGroupListMain: [
        {
          
          
            groupTitle: "Summery",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View all employee’s summary sections",
              name: "employees_summary",
              value: "employees_summary",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Personal",
          checkBoxGroupList: [
            {
              label: "View all employee’s personal sections",
              name: "View all employee’s personal sections",
              value: "View all employee’s personal sections",
            },
            {
              label: "Edit all employee’s personal sections",
              name: "Edit all employee’s personal sections",
              value: "Edit all employee’s personal sections",
            },
          ],
        },
        {
          
            groupTitle: "Work",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View all employee’s work sections",
              name: "View all employee’s work sections",
              value: "View all employee’s work sections",
            },
            {
              label: "Edit all employee’s work sections",
              name: "Edit all employee’s work sections",
              value: "Edit all employee’s work sections",
            },
          ],
        },
        {
          
            groupTitle: "Financials",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View all employee’s financials sections",
              name: "View all employee’s financials sections",
              value: "View all employee’s financials sections",
            },
            {
              label: "Edit all employee’s financials sections",
              name: "Edit all employee’s financials sections",
              value: "Edit all employee’s financials sections",
            },
          ],
        },
        {
          
            groupTitle: "Club View",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View the company’s clubs view",
              name: "View the company’s clubs view",
              value: "View the company’s clubs view",
            },
          ],
        },
        {
          
            groupTitle: "Organisatio Chart",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View the organisation chart",
              name: "View the organisation chart",
              value: "View the organisation chart",
            },
          ],
        },
        {
          
            groupTitle: "Directory",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View the people’s directory",
              name: "View the people’s directory",
              value: "View the people’s directory",
            },
          ],
        },
        {
          
            groupTitle: "Employees",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "Add new people to the company",
              name: "Add new people to the company",
              value: "Add new people to the company",
            },
            {
              label: "Delete people from the company",
              name: "Delete people from the company",
              value: "Delete people from the company",
            },
            {
              label: "Invite people to join the BuzzHR",
              name: "Invite people to join the BuzzHR",
              value: "Invite people to join the BuzzHR",
            },
            {
              label:
                "Create and manage employee through the ‘bulk import’ function ",
              name: "Create and manage employee through the ‘bulk import’ function ",
              value:
                "Create and manage employee through the ‘bulk import’ function ",
            },
          ],
        },
        {
          
            groupTitle: "Recruitment",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View company’s recuritment",
              name: "View company’s recuritment",
              value: "View company’s recuritment",
            },
            {
              label: "Create and edit jobs",
              name: "Create and edit jobs",
              value: "Create and edit jobs",
            },
            {
              label: "Manage candidates",
              name: "Manage candidates",
              value: "Manage candidates",
            },
          ],
        },
      ],
    },
    {
        id:"Time",
      title: "Time",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Time Off",
          checkBoxGroupList: [
            {
              label: "View all employees’ time off",
              name: "View all employees’ time off",
              value: "View all employees’ time off",
            },
            {
              label: "Manage all employees’ time off",
              name: "Manage all employees’ time off",
              value: "Manage all employees’ time off",
            },
          ],
        },
        {
          
            groupTitle: "Leave Balance ",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "View all employees’ leave balance",
              name: "View all employees’ leave balance",
              value: "View all employees’ leave balance",
            },
            {
              label: "Manage all employees’ leave balance",
              name: "Manage all employees’ leave balance",
              value: "Manage all employees’ leave balance",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Requests",

          checkBoxGroupList: [
            {
              label: "Create and manage all employees’ time off requests",
              name: "Create and manage all employees’ time off requests",
              value: "Create and manage all employees’ time off requests",
            },
            {
              label:
                "View, approve or decline all employees’ time off requests",
              name: "View, approve or decline all employees’ time off requests",
              value:
                "View, approve or decline all employees’ time off requests",
            },
            {
              label:
                "Update or cancel employees apporved past time off requests",
              name: "Update or cancel employees apporved past time off requests",
              value:
                "Update or cancel employees apporved past time off requests",
            },
            {
              label: "Edit or cancel approved future time off requests",
              name: "Edit or cancel approved future time off requests",
              value: "Edit or cancel approved future time off requests",
            },
            {
              label: "Add attachments to everyone’s time off requests",
              name: "Add attachments to everyone’s time off requests",
              value: "Add attachments to everyone’s time off requests",
            },
            {
              label:
                "Create time off requests through the ‘bulk import’ function",
              name: "Create time off requests through the ‘bulk import’ function",
              value:
                "Create time off requests through the ‘bulk import’ function",
            },
          ],
        },
        {
          
            groupTitle: "See Who’s Out Today ",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "See who’s out today",
              name: "See who’s out today",
              value: "See who’s out today",
            },
          ],
        },
      ],
    },
    {
        id:"Attendance",
      title: "Attendance",
      checkboxGroupListMain: [
        {
          
            groupTitle: "Attandence",
          grouptitleIsChecked:true,
          checkBoxGroupList: [
            {
              label: "Clock in & clock out for all employees",
              name: "Clock in & clock out for all employees",
              value: "Clock in & clock out for all employees",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Timesheet",
          checkBoxGroupList: [
            {
              label: "View all employees’ timesheet ",
              name: "View all employees’ timesheet ",
              value: "View all employees’ timesheet ",
            },
            {
              label: "Download all employees’ timesheet ",
              name: "Download all employees’ timesheet ",
              value: "Download all employees’ timesheet ",
            },
          ],
        },
      ],
    },
    {
        id:"Growth",
      title: "Growth",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Surveys",
          checkBoxGroupList: [
            {
              label: "View all surveys",
              name: "View all surveys",
              value: "View all surveys",
            },
            {
              label: "Manage all surveys",
              name: "Manage all surveys",
              value: "Manage all surveys",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Performance ",
          checkBoxGroupList: [
            {
              label: "View all employees; evalutaion ",
              name: "View all employees; evalutaion ",
              value: "View all employees; evalutaion ",
            },
            {
              label: "Manage all employees’ evaluation ",
              name: "Manage all employees’ evaluation ",
              value: "Manage all employees’ evaluation ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Goals",

          checkBoxGroupList: [
            {
              label: "Create, edit and check in company goals ",
              name: "Create, edit and check in company goals ",
              value: "Create, edit and check in company goals ",
            },
            {
              label: "View company shared goals ",
              name: "View company shared goals ",
              value: "View company shared goals ",
            },
            {
              label: "View company personal goals ",
              name: "View company personal goals ",
              value: "View company personal goals ",
            },
            {
              label: "Create and edit other employees’ individual goals ",
              name: "Create and edit other employees’ individual goals ",
              value: "Create and edit other employees’ individual goals ",
            },
            {
              label: "Check in other employees’ individual goals ",
              name: "Check in other employees’ individual goals ",
              value: "Check in other employees’ individual goals ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "One on One ",
          checkBoxGroupList: [
            {
              label: "Create one on one meetings with employees ",
              name: "Create one on one meetings with employees ",
              value: "Create one on one meetings with employees ",
            },
            {
              label: "Manage all employees’ one on one ",
              name: "Manage all employees’ one on one ",
              value: "Manage all employees’ one on one ",
            },
          ],
        },
      ],
    },
    {
      id:"Files",
      title: "Files",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "My Files",
          checkBoxGroupList: [
            {
              label: "Upload files",
              name: "Upload files",
              value: "Upload files",
            },
            {
              label: "Manage files",
              name: "Manage files",
              value: "Manage files",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Employee files ",
          checkBoxGroupList: [
            {
              label: "View all employees’ files ",
              name: "View all employees’ files ",
              value: "View all employees’ files ",
            },
            {
              label: "Manage all employees’ files   ",
              name: "Manage all employees’ files   ",
              value: "Manage all employees’ files   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Company files",

          checkBoxGroupList: [
            {
              label: "View company files  ",
              name: "View company files  ",
              value: "View company files  ",
            },
            {
              label: "Manage company files   ",
              name: "Manage company files   ",
              value: "Manage company files   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Confidential files",
          checkBoxGroupList: [
            {
              label: "View confidential files ",
              name: "View confidential files  ",
              value: "View confidential files  ",
            },
            {
              label: "Manage confidential files   ",
              name: "Manage confidential files   ",
              value: "Manage confidential files   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "E-sign files",
          checkBoxGroupList: [
            {
              label: "View e-sign files ",
              name: "View e-sign files  ",
              value: "View e-sign files  ",
            },
            {
              label: "Manage e-sign files    ",
              name: "Manage e-sign files    ",
              value: "Manage e-sign files    ",
            },
          ],
        },
      ],
    },
    {
        id:"Tasks",
      title: "Tasks",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "My Tasks",
          checkBoxGroupList: [
            {
              label: "View Tasks",
              name: "View Tasks",
              value: "View Tasks",
            },
            {
              label: "Manage Tasks",
              name: "Manage Tasks",
              value: "Manage Tasks",
            },
            {
              label: "Create and manage all employees’ tasks",
              name: "Create and manage all employees’ tasks",
              value: "Create and manage all employees’ tasks",
            },
            {
              label: "Mark as complete individual employees tasks",
              name: "Mark as complete individual employees tasks",
              value: "Mark as complete individual employees tasks",
            },
          ],
        },
      ],
    },
    {
        id:"Benefits",
      title: "Benefits",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Active Benefits",
          checkBoxGroupList: [
            {
              label: "Add and manage everyone’s active benefits",
              name: "Add and manage everyone’s active benefits",
              value: "Add and manage everyone’s active benefits",
            },
          ],
        },
      ],
    },
    {
        id:"Analysis",
      title: "Analysis",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "KPI Dashboards",
          checkBoxGroupList: [
            {
              label: "View KPI dashboards",
              name: "View KPI dashboards",
              value: "View KPI dashboards",
            },
            {
              label: "Manage KPI dashbords",
              name: "Manage KPI dashbords",
              value: "Manage KPI dashbords",
            },
            {
              label: "Export KPI dashboards",
              name: "Export KPI dashboards",
              value: "Export KPI dashboards",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Reports ",
          checkBoxGroupList: [
            {
              label: "View all reports",
              name: "View all reports",
              value: "View all reports",
            },
            {
              label: "Create and edit reports   ",
              name: "Create and edit reports   ",
              value: "Create and edit reports   ",
            },
            {
              label: "Export visible information from directory or reports  ",
              name: "Export visible information from directory or reports  ",
              value: "Export visible information from directory or reports  ",
            },
            {
              label: "Create scheduled reports  ",
              name: "Create scheduled reports  ",
              value: "Create scheduled reports  ",
            },
          ],
        },
      ],
    },
    {
        id:"Settings",
      title: "Settings",
      checkboxGroupListMain: [
        {
          
          grouptitleIsChecked:true,
            groupTitle: "This Company",
          checkBoxGroupList: [
            {
              label: "Edit the company’s details (name, logo, etc.)",
              name: "Edit the company’s details (name, logo, etc.)",
              value: "Edit the company’s details (name, logo, etc.)",
            },
            {
              label: "Delete the company profile and all its data",
              name: "Delete the company profile and all its data",
              value: "Delete the company profile and all its data",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Calendar Settings ",
          checkBoxGroupList: [
            {
              label: "Manage company calendars ",
              name: "Manage company calendars ",
              value: "Manage company calendars ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Site Settings ",
          checkBoxGroupList: [
            {
              label: "Manage company sites  ",
              name: "Manage company sites  ",
              value: "Manage company sites  ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Billing",
          checkBoxGroupList: [
            {
              label: "Manage billing  ",
              name: "Manage billing   ",
              value: "Manage billing   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Time Off",
          checkBoxGroupList: [
            {
              label: "View company’s time off settings ",
              name: "View company’s time off settings  ",
              value: "View company’s time off settings  ",
            },
            {
              label: "Manage company’s time off settings   ",
              name: "Manage company’s time off settings    ",
              value: "Manage company’s time off settings    ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Attendance",
          checkBoxGroupList: [
            {
              label: "Create and manage attendance shifts  ",
              name: "Create and manage attendance shifts   ",
              value: "Create and manage attendance shifts   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Surveys",
          checkBoxGroupList: [
            {
              label: "Create, manage and begin surveys  ",
              name: "Create, manage and begin surveys   ",
              value: "Create, manage and begin surveys   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Performace",
          checkBoxGroupList: [
            {
              label: "Create and manage evaluation form  ",
              name: "Create and manage evaluation form   ",
              value: "Create and manage evaluation form   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "One on One",
          checkBoxGroupList: [
            {
              label: "Create and manage templates  ",
              name: "Create and manage templates   ",
              value: "Create and manage templates   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Files",
          checkBoxGroupList: [
            {
              label: "Create and manage files folders  ",
              name: "Create and manage files folders   ",
              value: "Create and manage files folders   ",
            },
            {
              label: "Create and manage e-sign templates   ",
              name: "Create and manage e-sign templates    ",
              value: "Create and manage e-sign templates    ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Tasks",
          checkBoxGroupList: [
            {
              label: "Create and assign tasks  ",
              name: "Create and assign tasks   ",
              value: "Create and assign tasks   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Benefits",
          checkBoxGroupList: [
            {
              label: "Add, manage and purchase beneifts  ",
              name: "Add, manage and purchase beneifts   ",
              value: "Add, manage and purchase beneifts   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "API Access",
          checkBoxGroupList: [
            {
              label: "Manage API token  ",
              name: "Manage API token   ",
              value: "Manage API token   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Integrations",
          checkBoxGroupList: [
            {
              label: "Create, update and delete the integration  ",
              name: "Create, update and delete the integration   ",
              value: "Create, update and delete the integration   ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Permission Settings",
          checkBoxGroupList: [
            {
              label:
                "Manage authorization groups and log in as other people   ",
              name: "Manage authorization groups and log in as other people    ",
              value:
                "Manage authorization groups and log in as other people    ",
            },
          ],
        },
        {
          
          grouptitleIsChecked:true,
            groupTitle: "Personalisation",
          checkBoxGroupList: [
            {
              label: "Change look and feel   ",
              name: "Change look and feel    ",
              value: "Change look and feel    ",
            },
          ],
        },
      ],
    },
  ];